import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Contract.module.scss';
import styles2 from '../../../styles/Accordion.module.scss';
import { clickTracker, getProjectId, getTextWithNoSpace } from '../../../lib/common';
import { handleImpressionsTrack } from '../../../api';
import { useAuth } from '../../../contexts/auth';

const ContractActivation = ({ contractDetails, contractResp }) => {
  const titlesObj = {
    startDate: 'Signed Date',
    status: 'Status',
    reason: 'Reason',
    expiredOn: 'Expired On',
  };
  const projectId = getProjectId();
  const stylesObj = {
    Active: styles.Summary__Status__Active,
    InActive: styles.Summary__Status__Cancelled,
  };
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showMore, setShowMore] = useState(true);
  const [authState] = useAuth();

  const handleUpgradeClick = () => {
    const { manageCampaignURL } = contractResp;
    if (manageCampaignURL) {
      window.location.href = manageCampaignURL;
    }
  };

  let sortedData = [];
  if (contractDetails && contractDetails.length > 0) {
    sortedData = contractDetails.sort((a, b) => {
      if (a.status === 'Active' && b.status !== 'Active') {
        return -1;
      }
      if (a.status !== 'Active' && b.status === 'Active') {
        return 1;
      }
      return 0;
    });
  }

  const updatedCampaignsArr = showMore
    ? sortedData && sortedData.length > 0
      ? sortedData.slice(0, 3)
      : sortedData
    : sortedData;

  return (
    <div className="p-20">
      <div className={`${styles.Heading}`}>
        <div className={`${styles.Title} font16 fw700 color111`}>Activation Status</div>
      </div>
      <div className={`${styles.StatusBox} mt-20`}>
        {updatedCampaignsArr?.length > 0
          ? updatedCampaignsArr?.map((each, idx) => (
              <div
                aria-label="activation_status_change"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                key={idx}
                className={`${styles.Summary} ${idx === activeIndex && styles.Summary__Active} mt-10`}
                onClick={async () => {
                  setActiveIndex(idx === activeIndex ? -1 : idx);
                  if (idx !== activeIndex) {
                    const activeType =
                      projectId === 'csportal'
                        ? 'contract_campaignstatus'
                        : projectId === 'genio'
                          ? 'genio_contract_campaignstatus'
                          : null;
                    await clickTracker('contract_campaignstatus', activeType);
                    if (projectId === 'csportal') {
                      const liVal = 'click';
                      const liTrd = `click_${getTextWithNoSpace(each?.campaignName)}`;
                      const faqTypeVal = '';
                      const othersData = [];
                      const llTrd = 'click_activationstatus';
                      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                    }
                  }
                }}
              >
                <div className={`${styles.Summary__Pannel}`}>
                  <div className={`${styles.Summary__title} font13 fw500 color111`}>{each?.campaignName}</div>
                  <div className={`${styles.Summary__Drop__Icon} csicon`} />
                </div>
                <div className={`${styles.Summary__Details}`}>
                  {Object.keys(titlesObj).map(
                    (titleKey, index) =>
                      ((each?.status === 'Active' && !['reason', 'expiredOn'].includes(titleKey)) ||
                        each?.status === 'InActive') && (
                        <div className={`${styles.Summary__ItemList}`} key={index}>
                          <div className={`${styles.Summary__ItemLable} font13 fw500 color777`}>
                            {titlesObj?.[titleKey]} :
                          </div>
                          <div
                            className={`${styles.Summary__Item} ${
                              titleKey === 'status' ? stylesObj?.[each?.status] : styles.Summary__Date
                            } font13 fw600`}
                          >
                            {each?.[titleKey] || '--'}
                          </div>
                        </div>
                      ),
                  )}
                  {projectId === 'csportal' && each?.status === 'InActive' && (
                    <div className="mt-10">
                      <button
                        type="button"
                        className={`${styles.UpgradeButon} bluefill_animate font14 fw600 colorFFF mt-20`}
                        onClick={() => handleUpgradeClick()}
                      >
                        Upgrade
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))
          : null}
        {contractDetails?.length > 3 && (
          <div className="text_center pt-10 pl-20 pr-20">
            <button
              type="button"
              className={`${styles2.viewMore__Btn}`}
              onClick={() => {
                setShowMore((prev) => !prev);
              }}
            >
              {showMore ? 'View More' : 'View Less'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractActivation;

ContractActivation.propTypes = {
  contractDetails: PropTypes.array,
  contractResp: PropTypes.object,
};
